import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import VenueForm from "../venue/VenueForm";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  border: "2px solid #bb86fc",
  boxShadow: 24,
  p: 4,
};

const btnStyl = {
  marginTop: "14px",
  textAlign: "right",
};

export default function VenueModal(props: any) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    onClosemodal();
    setOpen(false);
  };
  const { onClosemodal } = props;
  return (
    <div>
      <Button sx={btnStyl} onClick={handleOpen} variant="outlined">
        {props.btnName}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {props.title}
          </Typography>
          <hr />
          <VenueForm
            venue={{
              name: "",
              address: "",
              description: "",
              countryId: "",
              id: "",
              cityId: "",
              fromModel: true,
            }}
            closemodal={handleClose}
          />
        </Box>
      </Modal>
    </div>
  );
}
